/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { TypographyKey } from 'theme/types'

import { LinkSize } from './types'

const typographyBySize: Record<LinkSize, TypographyKey> = {
  default: 'link',
  small: 'linkS',
  extraSmall: 'linkXs',
}

export const getLinkTypography = (size: LinkSize) => typographyBySize[size]
